interface Props {
  invocations: number
  maxInvocations: number
  maxHasBeenInvoked: boolean
}

const MintingProgress = ({ invocations, maxInvocations, maxHasBeenInvoked }: Props) => {
  const pct = Math.min((invocations / maxInvocations) * 100, 100)
  return (
    <div className="mb-6">
      <p className="text-sm font-medium text-gallery-text mb-2">
        {invocations} / {maxInvocations} sold
      </p>
      <div className="h-1 bg-gallery-border rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-500 ${maxHasBeenInvoked ? "bg-gallery-muted" : "bg-gallery-text"}`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  )
}

export default MintingProgress
